export default __webpack_public_path__ + "img/bg_publishing-dc19dcc4e9e2d226c764537ed1298606.png";